import { useState } from 'react'

const API_KEY    = 'op_live_80e9b88d362c56ba062cc131f8f6de1e3b914a611ce9607d'
const API_BASE   = import.meta.env.VITE_API_URL || 'https://api.kdpunt.com'
const GAMES_BASE = import.meta.env.VITE_GAME_SERVER_URL?.replace(':3002','') || 'https://games.kdpunt.com'

const GAMES = [
  {
    id: 'teen_patti_2card',
    name: 'Teen Patti 2-Card',
    desc: 'Classic 2-card Indian poker showdown. Back/Lay betting with instant results.',
    badge: 'LIVE', badgeColor: '#22c55e',
    category: 'Card Games',
    color: '#1e3a5f',
    icon: '🃏',
    gradient: 'linear-gradient(135deg, #1e3a5f 0%, #0f1e35 100%)',
    accentColor: '#3b82f6',
  },
  {
    id: 'teen_patti_3card',
    name: 'Teen Patti 3-Card',
    desc: 'Three-card Indian poker. Trail, Pure Sequence, Sequence and more bet types.',
    badge: 'LIVE', badgeColor: '#22c55e',
    category: 'Card Games',
    icon: '🎴',
    gradient: 'linear-gradient(135deg, #3b1f5e 0%, #1a0d2e 100%)',
    accentColor: '#8b5cf6',
  },
  {
    id: 'andar_bahar',
    name: 'Andar Bahar',
    desc: "India's favourite card game. Pick Andar or Bahar — one card decides your fate.",
    badge: 'LIVE', badgeColor: '#22c55e',
    category: 'Card Games',
    icon: '🎯',
    gradient: 'linear-gradient(135deg, #1a3a1a 0%, #0a1a0a 100%)',
    accentColor: '#22c55e',
  },
  {
    id: 'dragon_tiger',
    name: 'Dragon Tiger',
    desc: 'Epic battle between Dragon and Tiger. Simplest card game, highest excitement.',
    badge: 'LIVE', badgeColor: '#22c55e',
    category: 'Card Games',
    icon: '⚔️',
    gradient: 'linear-gradient(135deg, #3a0a0a 0%, #1a0505 100%)',
    accentColor: '#ef4444',
  },
  {
    id: 'aviator',
    name: 'Aviator',
    desc: 'Watch the multiplier soar! Cash out before the plane flies away.',
    badge: 'HOT 🔥', badgeColor: '#ef4444',
    category: 'Crash Games',
    icon: '✈️',
    gradient: 'linear-gradient(135deg, #040810 0%, #081408 100%)',
    accentColor: '#22c55e',
  },
  {
    id: 'chicken_road',
    name: 'Chicken Road',
    desc: 'Help the chicken hop over burning ovens. Each hop multiplies your winnings!',
    badge: 'NEW ✨', badgeColor: '#8b5cf6',
    category: 'Casual Games',
    icon: '🐔',
    gradient: 'linear-gradient(135deg, #1a1f35 0%, #0f1220 100%)',
    accentColor: '#f59e0b',
  },
  {
    id: 'stepping_stone',
    name: 'Stepping Stone',
    desc: 'Help the angry bird hop across river stones. One wrong step and it\'s a splash!',
    badge: 'NEW 🪨', badgeColor: '#1d6fa4',
    category: 'Casual Games',
    icon: '🐦',
    gradient: 'linear-gradient(135deg, #0a1628 0%, #1a3a5c 100%)',
    accentColor: '#2a9bc0',
  },
  // {
  //   id: 'village_andar_bahar',
  //   label: 'Village Andar Bahar',
  //   icon: '🎴',
  //   description: 'Traditional Indian card game with village vibes',
  //   category: 'Card Games',
  //   theme: '#16a34a',
  // },
  {
    id: 'indian_road',
    name: 'Indian Road',
    desc: 'Dodge potholes on a cracked Indian highway. Jump or crash!',
    badge: 'NEW 🪨', badgeColor: '#1d6fa4',
    icon: '🏍️',
    category: 'Casual Games',
    gradient: 'linear-gradient(135deg, #0a1628 0%, #1a3a5c 100%)',
    accentColor: '#2a9bc0',
  },
  {
    id: 'stock',
    name: 'Stock Trade',
    desc: 'Predict if the price goes UP or DOWN. Live chart, auto play, 1.94× payout.',
    badge: 'HOT 📈', badgeColor: '#60a5fa',
    category: 'Casual Games',
    icon: '📈',
    gradient: 'linear-gradient(135deg, #0d0b2a 0%, #1a1040 100%)',
    accentColor: '#60a5fa',
  },
  {
    id: 'balloon',
    name: 'Balloon',
    desc: 'Watch the balloon inflate — cash out before it pops! Higher risk, bigger reward.',
    badge: 'NEW 🎈', badgeColor: '#e879f9',
    category: 'Crash Games',
    icon: '🎈',
    gradient: 'linear-gradient(135deg, #0a0520 0%, #120a30 100%)',
    accentColor: '#e879f9',
  },
  {
    id: 'colorprediction',
    name: 'Color Prediction',
    desc: 'Predict Red, Green or Violet every 30 seconds. Pick numbers for 9× payout!',
    badge: 'HOT 🎨', badgeColor: '#a855f7',
    category: 'Casual Games',
    icon: '🎨',
    gradient: 'linear-gradient(135deg, #0f0f1a 0%, #1a0f2e 100%)',
    accentColor: '#a855f7',
  },
  {
    id: 'cricket',
    name: 'Cricket Sixes',
    desc: 'Hit sixes to grow your multiplier — retire before the wicket falls!',
    badge: 'NEW 🏏', badgeColor: '#4ade80',
    category: 'Casual Games',
    icon: '🏏',
    gradient: 'linear-gradient(135deg, #0a1a0a 0%, #0f2a10 100%)',
    accentColor: '#4ade80',
  },
  {
    id: 'crash3d',
    name: 'Crash 3D',
    desc: 'Spaceship flies higher — cash out before it crashes. Multiplier grows til blast off!',
    badge: 'NEW 🚀', badgeColor: '#88aaff',
    category: 'Crash Games',
    icon: '🚀',
    gradient: 'linear-gradient(135deg, #010208 0%, #0a0f2a 100%)',
    accentColor: '#88aaff',
  },
  {
    id: 'roulette',
    name: 'Roulette',
    desc: 'European single-zero roulette. Bet Red/Black, Dozens or Straight up to 35×.',
    badge: 'NEW 🎡', badgeColor: '#c9a84c',
    category: 'Casual Games',
    icon: '🎡',
    gradient: 'linear-gradient(135deg, #080f08 0%, #0f2010 100%)',
    accentColor: '#c9a84c',
  },
  {
    id: 'dice',
    name: 'Dice',
    desc: 'Roll 2 dice and bet Over or Under your target. Classic casino odds with 3D dice.',
    badge: 'NEW 🎲', badgeColor: '#c8873a',
    category: 'Casual Games',
    icon: '🎲',
    gradient: 'linear-gradient(135deg, #0a1a0e 0%, #1a3a1a 100%)',
    accentColor: '#c8873a',
  },
  {
    id: 'starburst',
    name: 'Starburst',
    desc: 'Win Both Ways slot with expanding wilds & free re-spins. NetEnt classic style.',
    badge: 'NEW ⭐', badgeColor: '#ff9900',
    category: 'Slot Games',
    icon: '⭐',
    gradient: 'linear-gradient(135deg, #0d0050 0%, #050018 100%)',
    accentColor: '#ff9900',
  },
  {
    id: 'slot',
    name: 'Fruit Slots',
    desc: '5-reel fruit slot with wilds, scatters, free spins & bonus round!',
    badge: 'NEW 🎰', badgeColor: '#ffd700',
    category: 'Slot Games',
    icon: '🎰',
    gradient: 'linear-gradient(135deg, #1a1400 0%, #2a2000 100%)',
    accentColor: '#ffd700',
  },
]

const CATEGORIES = ['All', 'Card Games', 'Crash Games', 'Casual Games', 'Slot Games']

function GameThumbnail({ game }: { game: typeof GAMES[0] }) {
  return (
    <div style={{
      width: '100%', height: '100%',
      background: game.gradient,
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Background pattern */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: `radial-gradient(circle at 20% 50%, ${game.accentColor}15 0%, transparent 50%),
                          radial-gradient(circle at 80% 20%, ${game.accentColor}10 0%, transparent 40%)`,
      }}/>

      {/* Grid lines */}
      <svg style={{ position:'absolute', inset:0, width:'100%', height:'100%', opacity:0.06 }}>
        {[0,20,40,60,80,100].map(x => (
          <line key={x} x1={`${x}%`} y1="0" x2={`${x}%`} y2="100%" stroke={game.accentColor} strokeWidth="1"/>
        ))}
        {[0,25,50,75,100].map(y => (
          <line key={y} x1="0" y1={`${y}%`} x2="100%" y2={`${y}%`} stroke={game.accentColor} strokeWidth="1"/>
        ))}
      </svg>

      {/* Icon */}
      <div style={{
        fontSize: 56, marginBottom: 8, lineHeight: 1,
        filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.5))',
      }}>
        {game.icon}
      </div>

      {/* Category pill */}
      <div style={{
        position: 'absolute', bottom: 10, left: '50%', transform: 'translateX(-50%)',
        background: `${game.accentColor}22`,
        border: `1px solid ${game.accentColor}44`,
        borderRadius: 20, padding: '3px 12px',
        fontSize: 10, fontWeight: 700,
        color: game.accentColor, whiteSpace: 'nowrap',
        letterSpacing: 0.5,
      }}>
        {game.category}
      </div>

      {/* Glow */}
      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0, height: 60,
        background: `linear-gradient(to top, ${game.accentColor}18, transparent)`,
      }}/>
    </div>
  )
}

export function DemoPage() {
  const [loading,  setLoading]  = useState<string | null>(null)
  const [error,    setError]    = useState<string | null>(null)
  const [category, setCategory] = useState('All')
  const [launched, setLaunched] = useState<string | null>(null)

  const launchGame = async (gameId: string) => {
    setLoading(gameId)
    setError(null)
    try {
      const playerId = 'player_001'
      const resp = await fetch(`${API_BASE}/api/v1/session/launch`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-API-Key': API_KEY },
        body: JSON.stringify({
          player_id:    playerId,
          game_type:    gameId,
          display_name: 'Demo Player',
          currency:     'coins',
        }),
      })
      const data = await resp.json()
      if (!resp.ok) throw new Error(data.error || 'Failed to launch game')
      window.open(data.launch_url, '_blank')
      setLaunched(gameId)
      setTimeout(() => setLaunched(null), 2000)
    } catch (e: any) {
      setError(e.message)
    } finally {
      setLoading(null)
    }
  }

  const filtered = category === 'All' ? GAMES : GAMES.filter(g => g.category === category)

  return (
    <div style={{
      minHeight: '100vh',
      overflowY: 'auto',
      position: 'relative',
      background: 'radial-gradient(ellipse at top, #0f1a35 0%, #060810 100%)',
      fontFamily: "'DM Sans', system-ui, sans-serif",
      color: '#e2e8f0',
    }}>

      {/* Hero */}
      <div style={{
        textAlign: 'center', padding: '60px 24px 40px',
        background: 'linear-gradient(180deg, rgba(201,168,76,0.06) 0%, transparent 100%)',
        borderBottom: '1px solid rgba(255,255,255,0.05)',
      }}>
        <div style={{ display:'inline-flex', alignItems:'center', gap:8, marginBottom:20, padding:'6px 16px', background:'rgba(201,168,76,0.1)', border:'1px solid rgba(201,168,76,0.2)', borderRadius:20 }}>
          <div style={{ width:6, height:6, borderRadius:'50%', background:'#22c55e', boxShadow:'0 0 8px #22c55e' }}/>
          <span style={{ fontSize:11, color:'#c9a84c', fontWeight:700, letterSpacing:1 }}>LIVE DEMO — PLAY MONEY ONLY</span>
        </div>

        <h1 style={{ fontSize:'clamp(28px,5vw,48px)', fontWeight:900, margin:'0 0 14px', lineHeight:1.1, letterSpacing:-1 }}>
          <span style={{ background:'linear-gradient(90deg,#c9a84c,#f0e68c,#c9a84c)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
            World-Class Casino Games
          </span>
          <br/>
          <span style={{ color:'white' }}>For Your Platform</span>
        </h1>

        <p style={{ fontSize:16, color:'#64748b', maxWidth:520, margin:'0 auto 32px', lineHeight:1.6 }}>
          Try all our games instantly. No registration required. Integrate via simple API.
        </p>

        {/* Stats */}
        <div style={{ display:'flex', justifyContent:'center', gap:'clamp(16px,4vw,48px)', flexWrap:'wrap' }}>
          {[
            { label:'Games', value:'9', icon:'🎮' },
            { label:'Live Players', value:'14.7K', icon:'👥' },
            { label:'Rounds Today', value:'284K', icon:'🎲' },
            { label:'Uptime', value:'99.9%', icon:'⚡' },
          ].map(s => (
            <div key={s.label} style={{ textAlign:'center' }}>
              <div style={{ fontSize:11, marginBottom:2 }}>{s.icon}</div>
              <div style={{ fontSize:22, fontWeight:800, color:'#c9a84c' }}>{s.value}</div>
              <div style={{ fontSize:10, color:'#334155', letterSpacing:1, textTransform:'uppercase' }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Category filter */}
      <div style={{ display:'flex', justifyContent:'center', gap:8, padding:'24px 16px 0', flexWrap:'wrap' }}>
        {CATEGORIES.map(cat => (
          <button key={cat} onClick={() => setCategory(cat)}
            style={{
              padding:'7px 18px', borderRadius:20, border:'none', cursor:'pointer',
              background: category===cat ? 'linear-gradient(135deg,#c9a84c,#a07830)' : 'rgba(255,255,255,0.05)',
              color: category===cat ? 'white' : '#64748b',
              fontSize:12, fontWeight:700, letterSpacing:.3,
              transition:'all 0.2s',
              boxShadow: category===cat ? '0 4px 16px rgba(201,168,76,0.3)' : 'none',
            }}>
            {cat}
          </button>
        ))}
      </div>

      {/* Error */}
      {error && (
        <div style={{ maxWidth:500, margin:'16px auto 0', padding:'10px 16px', background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:8, color:'#f87171', fontSize:13, textAlign:'center' }}>
          ⚠️ {error}
        </div>
      )}

      {/* Game grid */}
      <div style={{
        maxWidth: 1140, margin:'32px auto 0', padding:'0 20px 60px',
        display:'grid',
        gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))',
        gap:20,
      }}>
        {filtered.map(game => (
          <div key={game.id}
            style={{
              background:'#1e293b', borderRadius:16,
              border:'1px solid rgba(255,255,255,0.06)',
              overflow:'hidden', cursor:'pointer',
              transition:'all 0.25s',
              boxShadow:'0 4px 24px rgba(0,0,0,0.3)',
              opacity: loading && loading !== game.id ? 0.7 : 1,
            }}
            onMouseEnter={e => {
              const el = e.currentTarget as HTMLDivElement
              el.style.transform='translateY(-6px)'
              el.style.borderColor=`${game.accentColor}60`
              el.style.boxShadow=`0 16px 48px rgba(0,0,0,0.5), 0 0 0 1px ${game.accentColor}20`
            }}
            onMouseLeave={e => {
              const el = e.currentTarget as HTMLDivElement
              el.style.transform='translateY(0)'
              el.style.borderColor='rgba(255,255,255,0.06)'
              el.style.boxShadow='0 4px 24px rgba(0,0,0,0.3)'
            }}
          >
            {/* Thumbnail */}
            <div style={{ height:180, position:'relative' }}>
              <GameThumbnail game={game}/>

              {/* Badge */}
              <div style={{
                position:'absolute', top:12, left:12,
                padding:'3px 10px', borderRadius:20,
                background:game.badgeColor, color:'white',
                fontSize:10, fontWeight:700, letterSpacing:.5,
              }}>
                {game.badge}
              </div>

              {/* Launch indicator */}
              {launched === game.id && (
                <div style={{
                  position:'absolute', inset:0, background:'rgba(34,197,94,0.2)',
                  display:'flex', alignItems:'center', justifyContent:'center',
                  fontSize:32,
                }}>
                  ✅
                </div>
              )}

              {/* Loading spinner */}
              {loading === game.id && (
                <div style={{
                  position:'absolute', inset:0, background:'rgba(0,0,0,0.6)',
                  display:'flex', alignItems:'center', justifyContent:'center',
                }}>
                  <div style={{
                    width:32, height:32, borderRadius:'50%',
                    border:'3px solid rgba(255,255,255,0.1)',
                    borderTop:`3px solid ${game.accentColor}`,
                    animation:'spin 0.8s linear infinite',
                  }}/>
                </div>
              )}
            </div>

            {/* Info */}
            <div style={{ padding:'18px 18px 20px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:6 }}>
                <h3 style={{ margin:0, fontSize:16, fontWeight:800, color:'white' }}>{game.name}</h3>
                <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                  <div style={{ width:5, height:5, borderRadius:'50%', background:'#22c55e', boxShadow:'0 0 6px #22c55e' }}/>
                  <span style={{ fontSize:10, color:'#475569' }}>LIVE</span>
                </div>
              </div>

              <p style={{ margin:'0 0 16px', fontSize:12, color:'#64748b', lineHeight:1.6 }}>
                {game.desc}
              </p>

              <button
                onClick={() => launchGame(game.id)}
                disabled={!!loading}
                style={{
                  width:'100%', padding:'11px', border:'none', borderRadius:8,
                  background: loading === game.id
                    ? 'rgba(255,255,255,0.05)'
                    : `linear-gradient(135deg, ${game.accentColor}, ${game.accentColor}bb)`,
                  color: loading === game.id ? '#475569' : 'white',
                  fontSize:13, fontWeight:800, cursor: loading ? 'default' : 'pointer',
                  letterSpacing:.5, transition:'all 0.2s',
                  boxShadow: loading ? 'none' : `0 4px 16px ${game.accentColor}44`,
                }}
              >
                {loading === game.id ? 'Launching...' : launched === game.id ? '✓ Launched!' : '▶  PLAY NOW'}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* CTA Banner */}
      <div style={{
        maxWidth:900, margin:'0 auto 60px', padding:'0 20px',
      }}>
        <div style={{
          background:'linear-gradient(135deg, rgba(201,168,76,0.1) 0%, rgba(201,168,76,0.05) 100%)',
          border:'1px solid rgba(201,168,76,0.2)',
          borderRadius:16, padding:'32px 40px',
          display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:20,
        }}>
          <div>
            <h2 style={{ margin:'0 0 8px', fontSize:22, fontWeight:900, color:'white' }}>
              Ready to integrate?
            </h2>
            <p style={{ margin:0, fontSize:14, color:'#64748b', maxWidth:420 }}>
              Get API access and embed these games in your platform in minutes. Simple REST API, real-time Socket.io events.
            </p>
          </div>
          <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
            <a href="mailto:info@webodoctor.com"
              style={{
                padding:'12px 24px', borderRadius:8, textDecoration:'none',
                background:'linear-gradient(135deg,#c9a84c,#a07830)',
                color:'white', fontSize:13, fontWeight:800, letterSpacing:.5,
                boxShadow:'0 4px 16px rgba(201,168,76,0.3)',
              }}>
              Get API Access →
            </a>
            <a href="https://dashboard.kdpunt.com"
              style={{
                padding:'12px 24px', borderRadius:8, textDecoration:'none',
                background:'rgba(255,255,255,0.05)',
                border:'1px solid rgba(255,255,255,0.1)',
                color:'#94a3b8', fontSize:13, fontWeight:700,
              }}>
              Operator Login
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{ textAlign:'center', padding:'0 24px 40px', borderTop:'1px solid rgba(255,255,255,0.04)' }}>
        <p style={{ color:'#1e293b', fontSize:12, margin:'24px 0 4px' }}>© 2026 KDPunt Gaming Platform</p>
        <p style={{ color:'#1e293b', fontSize:11, margin:0 }}>All games use play money only • No real money • 18+ only</p>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg) } }
        * { box-sizing: border-box }
        body { margin: 0 }
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700;800;900&display=swap');
      `}</style>
    </div>
  )
}
